import { defineStore } from 'pinia';
import http from '@/services/http';

export const useUsersStore = defineStore('users', {
  state: () => ({
    users: [],
    user: null,
    loading: false,
    error: null
  }),

  getters: {
    getUsers: (state) => state.users,
    getUser: (state) => state.user,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  actions: {
    async fetchUsers() {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.get('/api/users');
        this.users = response.data;
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Laden der Benutzer';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async fetchUser(id) {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.get(`/api/users/${id}`);
        this.user = response.data;
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Laden des Benutzers';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async createUser(userData) {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.post('/api/users', userData);
        this.users.push(response.data);
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Erstellen des Benutzers';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async updateUser({ id, userData }) {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.put(`/api/users/${id}`, userData);
        
        // Benutzer in der Liste aktualisieren, falls vorhanden
        const index = this.users.findIndex(u => u.id === id);
        if (index !== -1) {
          this.users[index] = response.data;
        }
        
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Aktualisieren des Benutzers';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async deleteUser(id) {
      this.loading = true;
      this.error = null;
      
      try {
        await http.delete(`/api/users/${id}`);
        
        // Benutzer aus der Liste entfernen
        const index = this.users.findIndex(u => u.id === id);
        if (index !== -1) {
          this.users.splice(index, 1);
        }
        
        return true;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Löschen des Benutzers';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async updateProfile(profileData) {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.put('/api/profile', profileData);
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Aktualisieren des Profils';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    async updatePassword({ id, passwordData }) {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await http.put(`/api/users/${id}/password`, passwordData);
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || 'Fehler beim Ändern des Passworts';
        console.error(error);
        throw error;
      } finally {
        this.loading = false;
      }
    }
  }
}); 